import { dateFormat } from '@/utils/formatter'
export default {
    name:'date',
    format: (v) => {
        return v ? dateFormat(v, 'yyyy-MM-dd') : ''
    }
}